export const emailValidator = (email: string | undefined | null) => {
    if (email) {
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
    }
    return true;
};

export const phoneNumberValidator = (phone_number: string | undefined | null) => {
    if (phone_number) {
        return /^(?:(?:\+|00|)33|0|(?:\+|00|)590|(?:\+|00|)262|(?:\+|00|)594|(?:\+|00|)596|(?:\+|00|)508)\s*[1-9](?:[\s.-]*\d{2}){4}$/gim.test(phone_number);
    }
    return true;
};
